import Immutable from 'seamless-immutable';
import { ACTIONS } from './actions';

export const initialState = Immutable.from({
  accountMemberFilter: {
    companySearchInput: '',
    roleSearchInput: '',
    accessLevelSearchInput: '',
    statusSearchInput: '',
    selectedCompany: null,
    selectedRole: null,
    selectedAccessLevel: null,
    selectedStatus: null,
  },
  save: false,
});

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_STATUS:
      return state.merge(
        {
          accountMemberFilter: { selectedStatus: action.payload.value },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_STATUS_SEARCH_INPUT:
      return state.merge(
        {
          accountMemberFilter: { statusSearchInput: action.payload.value },
        },
        { deep: true }
      );
    case ACTIONS.SET_COMPANY:
      return state.merge(
        {
          accountMemberFilter: { selectedCompany: action.payload.value },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_COMPANY_SEARCH_INPUT:
      return state.merge(
        {
          accountMemberFilter: { companySearchInput: action.payload.value },
        },
        { deep: true }
      );
    case ACTIONS.SET_ROLE:
      return state.merge(
        {
          accountMemberFilter: { selectedRole: action.payload.value },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_ROLE_SEARCH_INPUT:
      return state.merge(
        {
          accountMemberFilter: { roleSearchInput: action.payload.value },
        },
        { deep: true }
      );
    case ACTIONS.SET_ACCESS_LEVEL:
      return state.merge(
        {
          accountMemberFilter: { selectedAccessLevel: action.payload.value },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_ACCESS_LEVEL_SEARCH_INPUT:
      return state.merge(
        {
          accountMemberFilter: { accessLevelSearchInput: action.payload.value },
        },
        { deep: true }
      );
    default:
      return state;
  }
};
